module.exports = __webpack_public_path__ + "img/in-banner.e71bfd3e.png";